module.exports = __webpack_public_path__ + "static/media/focomitral.c12facdb.png";